import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import {
  AppState,
  isUserAuthenticated,
  isFirstUserAccess,
} from '@app/store/store.states';
import { select, Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import { LogInRedirect } from '@app/store/auth/auth.actions';
import { combineLatest } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private readonly store: Store<AppState>) {}

  canActivate() {
    return combineLatest([
      this.store.pipe(select(isUserAuthenticated)),
      this.store.pipe(select(isFirstUserAccess)),
    ]).pipe(
      map(([isAuthenticated, firstAccess]) =>
        this.checkUserAccess(isAuthenticated, firstAccess)
      ),
      take(1)
    );
  }

  checkUserAccess(isAuthenticated: boolean = false, firstUserAccess = false) {
    if (!isAuthenticated || firstUserAccess) {
      this.store.dispatch(new LogInRedirect());
      return false;
    }
    return true;
  }
}
